import React from "react";

const ArticleWrapper = ({ children, expanded = false }) => {
  if (expanded) {
    return <div>{children}</div>;
  }

  return (
    <div className="wrapper wrapper--950">
      <div>{children}</div>
    </div>
  );
};

export default ArticleWrapper;
